import { render, staticRenderFns } from "./VideoControl.vue?vue&type=template&id=348dded1&scoped=true&lang=pug"
import script from "./VideoControl.vue?vue&type=script&lang=ts"
export * from "./VideoControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348dded1",
  null
  
)

export default component.exports